import React from 'react';
import { ColorPicker } from 'swag-client-common/components/color-picker';
import { LogoUploader } from 'swag-client-common/components/logo-uploader';
import { Buttons } from '../buttons';
import css from '../../edit-box-notecard-popup.scss';
export const LogoUploadStepComponent = ({
  boxItemsId = null,
  logo,
  color,
  isLogoLoading,
  isRevision,
  onNext,
  onBack,
  onColorChange,
  onLogoUpload,
  onLogoDelete,
  onProvideDesignLater,
  shouldUpdateInHandDate
}) => {
  const isNextButtonDisabled = Boolean(!logo || !color || isLogoLoading);
  const handleInputLogoChange = e => {
    onLogoUpload(e.target.files[0]);
  };
  const handleColorChange = color => {
    onColorChange(color.hex);
  };
  const handleRemoveColor = () => {
    onColorChange('');
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: css.title
  }, "Let\u2019s ", isRevision ? 'update' : 'design', " your notecard!"), /*#__PURE__*/React.createElement("div", {
    className: css.subTitle
  }, isRevision ? 'You can adjust your logo, colors, custom text or design from what you originally submitted.' : 'Upload your logo and select your brand color. You will then be able to add your custom text. You can also upload your own design.'), /*#__PURE__*/React.createElement("div", {
    className: css.content
  }, /*#__PURE__*/React.createElement(LogoUploader, {
    isLogoDeletable: true,
    isLoading: isLogoLoading,
    logoWrapperClassName: css.logoWrapper,
    logoBlockClassName: css.logoBlock,
    handleLogoChange: handleInputLogoChange,
    handleDeleteLogo: onLogoDelete,
    currentLogo: logo,
    buttonText: logo ? 'Change logo' : 'Upload your logo'
  }), /*#__PURE__*/React.createElement(ColorPicker, {
    currentColor: color,
    handleColorChange: handleColorChange,
    handleRemoveColor: handleRemoveColor,
    colorBlockClassName: css.colorBlock,
    colorLabelClassName: css.colorLabel,
    headline: "Pick a brand color"
  })), !isRevision && /*#__PURE__*/React.createElement("div", {
    onClick: onProvideDesignLater,
    className: css.pinkLink
  }, "I want to do this later and send over my design"), isRevision && shouldUpdateInHandDate && /*#__PURE__*/React.createElement("div", {
    className: css.inHandDateChangeMessage
  }, "It will take up to 3 business days for us to get a revised production mockup to you. This revision will delay the delivery date of your order by a few business days, so please plan to review and approve your updated production mockup as soon as you receive it. We will provide an updated delivery date for your order as soon as it is available."), /*#__PURE__*/React.createElement(Buttons, {
    nextButtonDisabled: isNextButtonDisabled,
    nextText: "Continue",
    backText: isRevision ? 'Cancel Revisions' : "I Don't Want A Notecard",
    onNextButton: onNext,
    onBackButton: () => onBack(boxItemsId)
  }));
};